module.exports = __webpack_public_path__ + "static/media/tiktok.ff3c9a20.png";